module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"start":"Los geht\u0027s","error":"Bitte entschuldigen Sie, es ist ein Fehler aufgetreten. Bitte nehmen Sie mit uns Kontakt auf."},"en":{"start":"Let\u0027s go","error":"We are sorry, an error has occurred. Please contact us."}}')
  delete Component.options._Ctor
}
